import axios, {AxiosResponse} from "axios";
import {Cache} from "./Cache"
import {StoreApiResponse, Store} from "@/models/StoreModel";
import {configuration} from "@/composables/ConfigurationComposition";

const storeCache = new Cache<Store[]>();

/**
 * fetch stores for given parameters
 *
 * @param lat
 * @param lng
 * @param distance
 * @param region
 * @param type
 * @param country
 */
export function fetchStores(searchQuery: string, lat: number, lng: number, distance: number, region: string, type: string, country: string) {
    return new Promise<Store[]>((resolve) => {
        const url = configuration.apiEndpointTemplate(searchQuery, lat, lng, distance, region, type, country);
        const cachedData = storeCache.get(url);

        if (cachedData !== undefined) {
            resolve(cachedData);
        } else {
            axios.get(url)
                .then((response: AxiosResponse<StoreApiResponse>) => {
                    const stores: Store[] = [];

                    for (const [key, value] of Object.entries(response.data.stores[0].results)) {
                        if (typeof value === 'object') {
                            value.type = 'default'; // necessary to map the map marker image

                            stores.push(value)
                        }
                    }

                    storeCache.set(url, stores);

                    resolve(stores);
                })
                .catch(e => {
                    resolve([]);
                })
        }
    });
}
